import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import companyReducer from './slices/companySlice';
import scenarioReducer from './slices/scenarioSlice';
import sessionReducer from './slices/sessionSlice';
import conversationReducer from './slices/conversationSlice';
import evaluationReducer from './slices/evaluationSlice';
import uiReducer from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    company: companyReducer,
    scenario: scenarioReducer,
    session: sessionReducer,
    conversation: conversationReducer,
    evaluation: evaluationReducer,
    ui: uiReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
